if (!customElements.get('mfs-bedding-filters')) {
  customElements.define('mfs-bedding-filters', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.section = document.getElementById('shopify-section-' + this.dataset.sectionId);
      this.products = new Map(JSON.parse(this.querySelector('[data-products]').textContent).map(p => [p.handle,p]));
      this.originals = new WeakMap();
      this.controls = [...this.querySelectorAll('select')];
      this.prepare();
      this.readUrl();
      this.addEventListener('change', () => { this.writeUrl(); this.render(); }, {signal:this.abort.signal});
      this.querySelector('[data-reset]').addEventListener('click', () => { this.controls.forEach(s => s.value=s.name==='mfs_size'&&this.dataset.fixedSize?this.dataset.fixedSize:'all'); this.writeUrl(); this.render(); }, {signal:this.abort.signal});
      window.addEventListener('popstate', () => {this.readUrl(); this.render();}, {signal:this.abort.signal});
      this.observer = new MutationObserver(changes => {
        if(changes.some(c => c.target.tagName==='PRODUCT-LIST' || [...c.addedNodes].some(n => n.nodeType===1 && (n.matches('product-list,product-card') || n.querySelector('product-list'))))) this.render();
      });
      this.observer.observe(this.section,{childList:true,subtree:true});
      this.render();
    }
    prepare() {
      const colours=['Brilliant White','Cream','Ivory','Champagne','Oyster Grey','Midnight Blue','Charcoal','Pastel Blue','Precious Pink','Teal Breeze','Sage Green'];
      const flatSizeLabels=new Map();
      const fittedOnly=[...this.products.values()].every(p=>/fitted sheet/i.test(p.kind));
      const normaliseDimensions=s=>s.replace(/\s*x\s*/g,' x ').replace(/\s*cm/g,' cm');
      const flatOnly=[...this.products.values()].every(p=>/flat sheet/i.test(p.kind));
      const dimensions={kind:new Set(),size:new Set(),colour:new Set(),style:new Set(),pillow:new Set(),depth:new Set()};
      for(const p of this.products.values()) {
        p.style=/oxford/i.test(p.title)?'Oxford':/piping|piped/i.test(p.title)?'Contrast piping':'Classic';
        p.colours=colours.filter(c=>p.tags.includes(c)||p.title.toLowerCase().includes(c.toLowerCase()));
        dimensions.kind.add(p.kind);dimensions.style.add(p.style);p.colours.forEach(c=>dimensions.colour.add(c));
        for(const v of p.variants){
          const originalSize=v.size;
          const raw=v.size.toLowerCase();v.size=raw.includes('emperor')?'Emperor':raw.includes('super king')?'Super King':raw.includes('single')?'Single':raw.includes('double')?'Double':raw.includes('king')?'King':v.size;
          const d=v.label.match(/(30|35|40)\s*cm/i);v.depth=d?d[1]+' cm':'';
          v.pillow=/pillowcase/i.test(v.label)?(/super king pillowcase/i.test(v.label)?'Super King (50 × 90 cm)':'Standard (50 × 75 cm)'):'';if(v.pillow)dimensions.pillow.add(v.pillow);
          if(fittedOnly)v.size=normaliseDimensions(originalSize);
          if(flatOnly)flatSizeLabels.set(v.size,originalSize);
          dimensions.size.add(v.size);if(v.depth)dimensions.depth.add(v.depth);
        }
      }
      const sizeOrder=['Single','Double','King','Super King','Emperor'];
      for(const [key,values] of Object.entries(dimensions)){
        const select=this.querySelector('[name="mfs_'+key+'"]');
        const rank=s=>sizeOrder.findIndex(n=>s===n||s.startsWith('UK '+n+' '));
        const choices=[...values].sort((a,b)=>key==='size'?(rank(a)-rank(b)||a.localeCompare(b)):a.localeCompare(b));
        for(const value of choices){const option=document.createElement('option');option.value=value;option.textContent=key==='size'&&flatOnly?(flatSizeLabels.get(value)||value):value;select.append(option);}
        select.closest('label').hidden=choices.length<2;
      }
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.abort=null; }
    readUrl() {
      const params=new URL(location.href).searchParams;
      let normaliseSize=false;
      this.controls.forEach(s=>{
        let v=s.name==='mfs_size'&&this.dataset.fixedSize?this.dataset.fixedSize:params.get(s.name)||'all';
        if(s.name==='mfs_depth')v='all';
        if(s.name==='mfs_size') {
          const aliases={super:'king',standard:'standard-queen'};
          if(Object.hasOwn(aliases,v)){v=aliases[v];normaliseSize=true;}
        }
        s.value=[...s.options].some(o=>o.value===v)?v:'all';
      });
      if(normaliseSize)this.writeUrl();
    }
    writeUrl() {
      const url=new URL(location.href);
      this.controls.forEach(s=>s.value==='all'||s.name==='mfs_size'&&this.dataset.fixedSize?url.searchParams.delete(s.name):url.searchParams.set(s.name,s.value));
      history.replaceState(history.state,'',url);
    }
    render() {
      const grid=this.section.querySelector('product-list'); if(!grid)return;
      const state=Object.fromEntries(this.controls.map(s=>[s.name,s.value]));
      let count=0;
      for(const card of grid.querySelectorAll('product-card')) {
        const p=this.products.get(card.getAttribute('handle')); if(!p)continue;
        if(!this.originals.has(card)) this.originals.set(card,{price:card.querySelector('price-list')?.innerHTML,links:[...card.querySelectorAll('a[href]')].map(a=>[a,a.getAttribute('href')]),images:[...card.querySelectorAll('.product-card__image')].map(img=>[img,Object.fromEntries(['src','srcset','alt','width','height'].map(key=>[key,img.getAttribute(key)]))]),quickBuy:card.querySelector('quick-buy-modal')?.getAttribute('handle')});
        const original=this.originals.get(card);
        const eligible=p.variants.filter(v=>(state.mfs_size==='all'||v.size===state.mfs_size)&&(state.mfs_depth==='all'||v.depth===state.mfs_depth)&&(state.mfs_pillow==='all'||v.pillow===state.mfs_pillow));
        const matches=eligible.length>0&&(state.mfs_kind==='all'||p.kind===state.mfs_kind)&&(state.mfs_colour==='all'||p.colours.includes(state.mfs_colour))&&(state.mfs_style==='all'||p.style===state.mfs_style);
        card.hidden=!matches; card.style.display=matches?'':'none';
        if(matches)count++;
        const price=card.querySelector('price-list');
        let note=card.querySelector('.mfs-filter-size-note');
        if(state.mfs_size==='all'&&state.mfs_depth==='all'&&state.mfs_pillow==='all') {
          if(price&&price.innerHTML!==original.price)price.innerHTML=original.price;
          original.links.forEach(([a,url])=>{if(a.isConnected)a.setAttribute('href',url);});
          original.images.forEach(([img,attrs])=>Object.entries(attrs).forEach(([key,value])=>value===null?img.removeAttribute(key):img.setAttribute(key,value)));
          const modal=card.querySelector('quick-buy-modal');if(modal&&original.quickBuy)modal.setAttribute('handle',original.quickBuy);
          if(note)note.remove();
          continue;
        }
        if(!eligible.length)continue;
        const available=eligible.filter(v=>v.available);
        const pool=available.length?available:eligible;
        const v=[...pool].sort((a,b)=>a.price-b.price)[0];
        original.links.forEach(([a,url])=>{if(a.isConnected){const u=new URL(url,location.origin);u.searchParams.set('variant',v.id);a.href=u.pathname+u.search+u.hash;}});
        if(v.image) {
          for(const [img] of original.images) {
            if(!img.isConnected)continue;
            const imageUrl=new URL(v.image.src,location.origin);
            const srcset=[200,300,400,500,600,700,800,1000,1200].filter(w=>w<=v.image.width).map(w=>{const u=new URL(imageUrl);u.searchParams.set('width',w);return u.href+' '+w+'w';}).join(', ');
            if(img.getAttribute('src')!==imageUrl.href){img.setAttribute('src',imageUrl.href);img.setAttribute('srcset',srcset);img.setAttribute('alt',v.image.alt);img.setAttribute('width',v.image.width);img.setAttribute('height',v.image.height);}
          }
        }
        const modal=card.querySelector('quick-buy-modal');if(modal)modal.setAttribute('handle',p.handle+'?variant='+v.id);
        if(price) {
          const from=new Set(pool.map(v=>v.price)).size>1?'<span class="mfs-price-prefix">'+this.dataset.from+'</span> ':'';
          const markup='<sale-price class="h6 '+(v.compare>v.price?'text-on-sale':'text-subdued')+'"><span class="sr-only">'+this.dataset.sale+'</span>'+from+v.money+'</sale-price>'+(v.compare>v.price?'<compare-at-price class="h6 text-subdued"><span class="sr-only">'+this.dataset.regular+'</span>'+v.compare_money+'</compare-at-price><span class="mfs-price-saving">'+this.dataset.savingTemplate.replace('__SAVING__',v.saving_money)+'</span>':'');
          if(price.innerHTML!==markup)price.innerHTML=markup;
          if(!note){note=document.createElement('p');note.className='mfs-filter-size-note';price.after(note);}
          note.textContent=v.label+(available.length?'':' · '+this.dataset.soldOut);
        }
      }
      const active=this.controls.some(s=>s.value!=='all'&&!(s.name==='mfs_size'&&this.dataset.fixedSize));
      this.querySelector('[data-reset]').hidden=!active;
      const countEl=this.section.querySelector('.collection-toolbar__products-count');
      if(countEl){countEl.textContent=this.dataset.count.replace('__COUNT__',count);countEl.setAttribute('aria-live','polite');}
      let empty=this.section.querySelector('.mfs-bedding-empty');
      if(!empty){empty=document.createElement('p');empty.className='mfs-bedding-empty';empty.setAttribute('role','status');grid.after(empty);}
      empty.textContent=this.dataset.empty;empty.hidden=count>0;
    }
  });
}
